import Navbar from "@/components/feature/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import ContactFooter from "./components/ContactFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-ding-black text-ding-cream">
      <Navbar />
      <Hero />
      <Services />
      <About />
      <ContactFooter />
    </div>
  );
}